import { render, staticRenderFns } from "./RcWidgetLiveResultsHouseWest.vue?vue&type=template&id=ac15bf36&"
import script from "./RcWidgetLiveResultsHouseWest.vue?vue&type=script&lang=js&"
export * from "./RcWidgetLiveResultsHouseWest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports